import { jsx as _jsx } from "react/jsx-runtime";
import { StyledPanelContent, StyledPanelDivider, StyledWrapper, } from './Panel.style';
export const Panel = ({ variant = 'default', direction = 'row', children, }) => (_jsx(StyledWrapper, { direction: direction, variant: variant, children: children }));
Panel.Content = StyledPanelContent;
Panel.Divider = StyledPanelDivider;
//# sourceMappingURL=Panel.js.map